module.exports = __webpack_public_path__ + "static/npckc1-a55c44fb33892da5fe037b507c5aa5b7.png";